// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__Lgy83","alertIcon":"ConfirmModal_alertIcon__16xPK"};